export const getZIndex = (zIndex) => ({ theme }) => theme.zIndex[zIndex];
export const getColor = (color) => ({ theme }) => color && theme.colors[color];
export const getColorByProps = (fallbackColor = "fg") => ({ color, theme }) =>
  color ? theme.colors[color] : theme.colors[fallbackColor];
